import { Component, OnInit } from '@angular/core';
import { ThemeModeService } from './modules/_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import {Platformetitle} from "@client";
import {NavigationEnd, Router} from "@angular/router";
import {GoogleTagManagerService} from "angular-google-tag-manager";



@Component({
  selector: 'lcms-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent implements OnInit {
  constructor(private modeService: ThemeModeService, private router: Router, private gtmService: GoogleTagManagerService){
    document.title = Platformetitle
  }
  title = 'shell';

  ngOnInit() {
    this.modeService.init();
    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
  }
}
